import SvgIcon from 'components/Icons/SvgIcon'
import React, { ClipboardEvent, ChangeEvent, FC } from 'react'
import { CloseButton } from 'react-bootstrap'
import COLORS from 'utils/__enums/Common/Color'

interface Props {
  value: string
  placeholder: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  type?: 'number' | 'text'
  className?: string
  icon?: string
  onClear?: () => void
  onPaste?: (e: ClipboardEvent<HTMLInputElement>) => void
}

const InputGroup: FC<Props> = ({
  type,
  value,
  placeholder,
  onChange,
  className,
  icon,
  onClear,
  onPaste,
}: Props) => {
  return (
    <div className="input-group">
      {icon && (
        <SvgIcon
          name={icon}
          color={COLORS.GRAY_1}
          className="input-group__icon"
        />
      )}
      <input
        type={type}
        className={`form-control input-group__field ${
          icon ? 'icon-padding' : ''
        } ${className}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onPaste={onPaste}
      />
      {onClear && value !== '' && (
        <CloseButton className="input-group__clear" onClick={onClear} />
      )}
    </div>
  )
}
InputGroup.defaultProps = {
  type: 'text',
  className: '',
  icon: '',
  onClear: undefined,
  onPaste: undefined,
}

export default InputGroup
